<div *ngIf="isLoadingBookmarks"
    style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
    <sh-spinner id="bookmark-menu-spinner-1"></sh-spinner>
</div>

<p-table *ngIf="!isLoadingBookmarks && bookmarks && selectedGroup === 'instruments'" [size]="'small'" #table
    [value]="bookmarks" [scrollable]="true" [scrollHeight]="'flex'" [customSort]="true" [sortField]="'serial'"
    [sortOrder]="-1" (sortFunction)="customSort($event)" [rows]="workareaSize === 'fullscreen' ? 10 : 5" [paginator]="true"
    [globalFilterFields]="instrumentGlobalFilterFields">

    <!-- Tools -->
    <ng-template #caption style="border: none;">
        <div style="display: flex; align-items: center; gap: 8px;">
            <i class="pi pi-bookmark-fill" style="font-size: 1.5rem; color: var(--text-primary); "></i>
            <sh-text id="bookmark-menu-text-2" size="title-1" style="flex: 1 1 30%;">{{ 'bookmarks.title' | transloco }}</sh-text>

            <div class="table-tools" style="flex: 1 1 70%; gap: 8px; align-items: center;">
                <sh-switch id="bookmark-menu-switch-3" style="margin-right: -8px" variant="squared" condensed>
                    <sh-switch-item [attr.label]="'bookmarks.switch.instruments' | transloco" id="instruments" [active]="$any(selectedGroup) === 'instruments'"
                        (click)="changeGroup($any('instruments'),$event)"></sh-switch-item>
                    <sh-tooltip id="bookmark-menu-tooltip-instruments"  target="instruments" [attr.label]="'bookmarks.switch.instruments' | transloco"></sh-tooltip>
                    <sh-switch-item [attr.label]="'bookmarks.switch.customerSites' | transloco" id="customer-sites" [active]="$any(selectedGroup) === 'sites'"
                        (click)="changeGroup($any('sites'),$event)"></sh-switch-item>
                    <sh-tooltip id="bookmark-menu-tooltip-customer-sites" target="customer-sites" [attr.label]="'bookmarks.switch.customerSites' | transloco"></sh-tooltip>
                </sh-switch>

                <sh-divider id="bookmark-menu-divider-6" spacing='s' style="height: 30px;" vertical></sh-divider>

                <sh-dropdown id="bookmark-menu-dropdown-7" no-border condensed style="max-width: 120px; margin-left: -8px; margin-right: -8px;" [attr.value]="(selectedRange === 7 ? 'bookmarks.range.7days' : selectedRange === 14 ? 'bookmarks.range.14days' : 'bookmarks.range.30days') | transloco">
                    <sh-menu-item id="bookmark-menu-menu-item-7-days" (click)="changeRange(7,'bookmark')" [attr.label]="'bookmarks.range.7days' | transloco"
                        [active]="selectedRange === 7"></sh-menu-item>
                    <sh-menu-item id="bookmark-menu-menu-item-14-days" (click)="changeRange(14,'bookmark')" [attr.label]="'bookmarks.range.14days' | transloco"
                        [active]="selectedRange === 14"></sh-menu-item>
                    <sh-menu-item id="bookmark-menu-menu-item-30-days" (click)="changeRange(30,'bookmark')" [attr.label]="'bookmarks.range.30days' | transloco"
                        [active]="selectedRange === 30"></sh-menu-item>
                </sh-dropdown>

                <sh-divider id="bookmark-menu-divider-11" spacing='s' style="height: 30px;" vertical></sh-divider>

                <sh-icon id="bookmark-menu-icon-12" style="margin-left: -8px;" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                <sh-icon id="bookmark-menu-icon-13" *ngIf="workareaSize !== 'fullscreen'" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'" button
                    (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                <sh-icon id="bookmark-menu-icon-expand" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" size="s" button (click)="onExpand($event)"></sh-icon>
                <sh-icon id="bookmark-menu-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                    [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
            </div>
        </div>
    </ng-template>


    <!-- Table Header -->
    <ng-template pTemplate="header">
        <tr>
            <th pFrozenColumn pSortableColumn="serial" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.serialNumber' | transloco }}<p-sortIcon field="serial" />
                </div>
            </th>
            <th pSortableColumn="instrumentName" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.product' | transloco }}<p-sortIcon field="instrumentName" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" colspan="4" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.systemHealth' | transloco }}</div>
            </th>
            <th *ngIf="showServiceDataColumns" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.serviceHistory' | transloco }}</div>
            </th>
            <th *ngIf="showInstrumentSiteColumn" pSortableColumn="FUNCTIONAL_LOCATION" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.site' | transloco }}<p-sortIcon
                        field="FUNCTIONAL_LOCATION" />
                </div>
            </th>
            <th style="min-width: 0px; text-align: center;" alignFrozen="right" pFrozenColumn>{{ 'bookmarks.table.actions' | transloco }}</th>
        </tr>

        <!-- Filter Row -->
        <tr>
            <th pFrozenColumn style="padding-top: 8px !important; padding-bottom: 8px !important;">
                <p-columnFilter style="width: 100%" type="text" [showMenu]="false" field="serial" matchMode="contains">
                    <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                        <sh-search id="bookmark-menu-search-serial-number" no-border [attr.label]="'bookmarks.filter.serialNumber' | transloco" condensed [(ngModel)]="searchTermSerial"
                            (ngModelChange)="filter($event)"></sh-search>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th style="padding-top: 8px !important; padding-bottom: 8px !important;">
                <p-columnFilter style="width: 100%;" type="text" [showMenu]="false" field="instrumentName"
                    matchMode="contains">
                    <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                        <sh-search id="bookmark-menu-search-type" no-border [attr.label]="'bookmarks.filter.type' | transloco" condensed [(ngModel)]="searchTermInstrument"
                            (ngModelChange)="filter($event)"></sh-search>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="maintenance"
                style="min-width: 125px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.maintenance' | transloco }}<p-sortIcon field="maintenance" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="autocheck"
                style="min-width: 115px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.autocheck' | transloco }}<p-sortIcon field="autocheck" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="events"
                style="min-width: 115px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.events' | transloco }}<p-sortIcon field="events" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="qc"
                style="min-width: 100px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.qc' | transloco }}<p-sortIcon field="qc" />
                </div>
            </th>
            <th *ngIf="showServiceDataColumns" pSortableColumn="noti"
                style="min-width: 125px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.openNotis' | transloco }}<p-sortIcon field="noti" />
                </div>
            </th>
            <th *ngIf="showInstrumentSiteColumn" style="padding-top: 8px !important; padding-bottom: 8px !important;">
                <p-columnFilter style="width: 100%;" type="text" [showMenu]="false" field="FUNCTIONAL_LOCATION"
                    matchMode="contains">
                    <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                        <sh-search id="bookmark-menu-search-site" no-border [attr.label]="'bookmarks.filter.site' | transloco" condensed [(ngModel)]="searchTermFuncloc"
                            (ngModelChange)="filter($event)"></sh-search>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th alignFrozen="right" style="padding-top: 8px !important; padding-bottom: 8px !important;" pFrozenColumn>
            </th>
        </tr>

    </ng-template>

    <!-- Rows -->
    <ng-template pTemplate="body" let-row let-expanded="expanded">
        <tr>
            <td pFrozenColumn>
                <sh-button id="bookmark-menu-button-18" (click)="changeInstrument(row)" [label]="row.serial" color="secondary"
                    size="auto" [disabled]="!row.FUNCTIONAL_LOCATION"></sh-button>
            </td>
            <td>
                {{row.instrumentName}}
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.metrics?.time_windows?.[selectedRange+'']?.maintenance"
                        type='warning' size="medium" show-label="true"
                        [label]="row.system_health.metrics.time_windows[selectedRange+''].maintenance+''"></sh-badge>
                    <span *ngIf="!row.system_health?.metrics?.time_windows?.[selectedRange+'']?.maintenance">-</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.metrics?.time_windows?.[selectedRange+'']?.autochecks"
                        type='warning' size="medium" show-label="true"
                        [label]="row.system_health?.metrics?.time_windows[selectedRange+''].autochecks+''"></sh-badge>
                    <span *ngIf="!row.system_health?.metrics?.time_windows?.[selectedRange+'']?.autochecks">-</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.metrics?.time_windows?.[selectedRange+'']?.error_events"
                        type='warning' size="medium" show-label="true"
                        style="background-color: var(--success-icon-color) !important"
                        [label]="row.system_health?.metrics?.time_windows[selectedRange+''].error_events+''"></sh-badge>
                    <span *ngIf="!row.system_health?.metrics?.time_windows?.[selectedRange+'']?.error_events">-</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.metrics?.time_windows?.[selectedRange+'']?.qc" type='warning'
                        size="medium" show-label="true" style="background-color: var(--success-icon-color) !important"
                        [label]="row.system_health?.metrics?.time_windows[selectedRange+''].qc+''"></sh-badge>
                    <span *ngIf="!row.system_health?.metrics?.time_windows?.[selectedRange+'']?.qc">-</span>
                </div>
            </td>
            <td *ngIf="showServiceDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true"
                        *ngIf="row.service_history?.metrics?.time_windows?.[selectedRange+'']?.notifications_open && !row.totally_down"
                        type='warning' size="medium" show-label="true"
                        [label]="row.service_history?.metrics?.time_windows[selectedRange+''].notifications_open+''"></sh-badge>
                    <sh-badge id="bookmark-menu-badge-true"
                        *ngIf="row.service_history?.metrics?.time_windows?.[selectedRange+'']?.notifications_open && row.totally_down"
                        type='error' size="medium" show-label="true"
                        [label]="row.service_history?.metrics?.time_windows[selectedRange+''].notifications_open+''"></sh-badge>
                    <span
                        *ngIf="!row.service_history?.metrics?.time_windows?.[selectedRange+'']?.notifications_open">-</span>
                </div>
            </td>
            <td *ngIf="showInstrumentSiteColumn">
                {{row.FUNCTIONAL_LOCATION}}
            </td>
            <td pFrozenColumn alignFrozen="right">
                <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                    <sh-icon id="bookmark-menu-icon-open-link" button icon="open-link" size="s" [disabled]="!row.FUNCTIONAL_LOCATION" (click)="changeInstrument(row)"></sh-icon>
                    <sh-icon id="bookmark-menu-icon-cancel" button icon="cancel" size="s" (click)="deleteBookmark($event, row)"></sh-icon>
                </div>

            </td>

        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="instrumentTableColspan">
                <div *ngIf="!isError"
                    style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                    <span>{{ 'bookmarks.empty.instruments' | transloco }}</span>
                </div>
                <div *ngIf="isError"
                    style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                    <sh-icon id="bookmark-menu-icon-error" icon="error" size="s"></sh-icon>
                    <span>{{ 'bookmarks.error.pullingData' | transloco }}</span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="paginatorleft">
        <div style="width: 160px;"></div>
    </ng-template>

    <ng-template pTemplate="paginatorright">
        <div style="display: flex; align-items: center; gap: 8px;">
            <span>{{ 'bookmarks.pagination.rowsPerPage' | transloco }}</span>
            <sh-dropdown id="bookmark-menu-dropdown-28" no-border condensed style="max-width: 80px;">
                <sh-menu-item id="bookmark-menu-menu-item-5" (click)="table.rows = 5; table.first = 0" label="5" [active]="table.rows === 5"></sh-menu-item>
                <sh-menu-item id="bookmark-menu-menu-item-10" (click)="table.rows = 10; table.first = 0" label="10" [active]="table.rows === 10"></sh-menu-item>
                <sh-menu-item id="bookmark-menu-menu-item-20" (click)="table.rows = 20; table.first = 0" label="20" [active]="table.rows === 20"></sh-menu-item>
                <sh-menu-item id="bookmark-menu-menu-item-50" (click)="table.rows = 50; table.first = 0" label="50" [active]="table.rows === 50"></sh-menu-item>
            </sh-dropdown>
        </div>
    </ng-template>

</p-table>


<!-- Sites -->
<p-table *ngIf="!isLoadingBookmarks && bookmarksSites && selectedGroup === 'sites'" [size]="'small'" #tableSites
    [value]="bookmarksSites" [scrollable]="true" [scrollHeight]="'flex'" [customSort]="true"
    [sortField]="'location_name'" [sortOrder]="-1" (sortFunction)="customSortSites($event)" [rows]="workareaSize === 'fullscreen' ? 10 : 5"
    [paginator]="true">

    <!-- Tools -->
    <ng-template #caption style="border: none;">
        <div style="display: flex; align-items: center; gap: 8px;">
            <i class="pi pi-bookmark-fill" style="font-size: 1.5rem; color: var(--text-primary); "></i>
            <sh-text id="bookmark-menu-text-33" size="title-1" style="flex: 1 1 30%;">{{ 'bookmarks.title' | transloco }}</sh-text>

            <div class="table-tools" style="flex: 1 1 70%; gap: 8px; align-items: center;">
                <sh-switch id="bookmark-menu-switch-34" style="margin-right: -8px" variant="squared" condensed>
                    <sh-switch-item [attr.label]="'bookmarks.switch.instruments' | transloco" id="instruments" [active]="$any(selectedGroup) === 'instruments'"
                        (click)="changeGroup($any('instruments'),$event)"></sh-switch-item>
                    <sh-tooltip id="bookmark-menu-tooltip-instruments"  target="instruments" [attr.label]="'bookmarks.switch.instruments' | transloco"></sh-tooltip>
                    <sh-switch-item [attr.label]="'bookmarks.switch.customerSites' | transloco" id="customer-sites" [active]="$any(selectedGroup) === 'sites'"
                        (click)="changeGroup($any('sites'),$event)"></sh-switch-item>
                    <sh-tooltip id="bookmark-menu-tooltip-customer-sites" target="customer-sites" [attr.label]="'bookmarks.switch.customerSites' | transloco"></sh-tooltip>

                </sh-switch>

                <sh-divider id="bookmark-menu-divider-37" spacing='s' style="height: 30px;" vertical></sh-divider>

                <sh-dropdown id="bookmark-menu-dropdown-38" no-border condensed style="max-width: 120px; margin-left: -8px; margin-right: -8px;" [attr.value]="(selectedRange === 7 ? 'bookmarks.range.7days' : selectedRange === 14 ? 'bookmarks.range.14days' : 'bookmarks.range.30days') | transloco">
                    <sh-menu-item id="bookmark-menu-menu-item-7-days" (click)="changeRange(7,'bookmark')" [attr.label]="'bookmarks.range.7days' | transloco"
                        [active]="selectedRange === 7"></sh-menu-item>
                    <sh-menu-item id="bookmark-menu-menu-item-14-days" (click)="changeRange(14,'bookmark')" [attr.label]="'bookmarks.range.14days' | transloco"
                        [active]="selectedRange === 14"></sh-menu-item>
                    <sh-menu-item id="bookmark-menu-menu-item-30-days" (click)="changeRange(30,'bookmark')" [attr.label]="'bookmarks.range.30days' | transloco"
                        [active]="selectedRange === 30"></sh-menu-item>
                </sh-dropdown>

                <sh-divider id="bookmark-menu-divider-42" spacing='s' style="height: 30px;" vertical></sh-divider>

                <sh-icon id="bookmark-menu-icon-43" style="margin-left: -8px;" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                <sh-icon id="bookmark-menu-icon-44" size="xs" *ngIf="workareaSize !== 'fullscreen'" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'" button
                    (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                
                <sh-icon id="bookmark-menu-icon-expand-site" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" size="s" button (click)="onExpand($event)"></sh-icon>
                <sh-icon id="bookmark-menu-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                    [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
            </div>
        </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
        <tr>
            <th pFrozenColumn pSortableColumn="location_name" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.sites.table.siteName' | transloco }}<p-sortIcon field="location_name" />
                </div>
            </th>
            <th pSortableColumn="country" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.sites.table.country' | transloco }}<p-sortIcon field="country" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="instrumentName" colspan="4" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.systemHealth' | transloco }}</div>
            </th>
            <th *ngIf="showServiceDataColumns" pSortableColumn="instrumentName" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.serviceHistory' | transloco }}</div>
            </th>
            <th pSortableColumn="addressFull" style="min-width: 150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.sites.table.address' | transloco }}<p-sortIcon field="addressFull" />
                </div>
            </th>
            <th style="min-width: 0px; text-align: center;" alignFrozen="right" pFrozenColumn>{{ 'bookmarks.table.actions' | transloco }}</th>
        </tr>

        <!-- Filter Row -->
        <tr>
            <th pFrozenColumn style="padding-top: 8px !important; padding-bottom: 8px !important;">
                <p-columnFilter style="width: 100%" type="text" [showMenu]="false" field="location_name"
                    matchMode="contains">
                    <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                        <sh-search id="bookmark-menu-search-name" no-border [attr.label]="'bookmarks.sites.filter.name' | transloco" condensed [(ngModel)]="searchTermName"
                            (ngModelChange)="filter($event)"></sh-search>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th style="padding-top: 8px !important; padding-bottom: 8px !important;">
                <p-columnFilter style="width: 100%" type="text" [showMenu]="false" field="country" matchMode="contains">
                    <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                        <sh-search id="bookmark-menu-search-country" no-border [attr.label]="'bookmarks.sites.filter.country' | transloco" condensed [(ngModel)]="searchTermCountry"
                            (ngModelChange)="filter($event)"></sh-search>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="maintenance"
                style="min-width: 125px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.maintenance' | transloco }}<p-sortIcon field="maintenance" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="autocheck"
                style="min-width: 115px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.autocheck' | transloco }}<p-sortIcon field="autocheck" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="events"
                style="min-width: 115px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.events' | transloco }}<p-sortIcon field="events" />
                </div>
            </th>
            <th *ngIf="showMachineDataColumns" pSortableColumn="qc"
                style="min-width: 100px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.qc' | transloco }}<p-sortIcon field="qc" />
                </div>
            </th>
            <th *ngIf="showServiceDataColumns" pSortableColumn="noti"
                style="min-width: 125px;padding-top: 8px !important; padding-bottom: 8px !important;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'bookmarks.table.openNotis' | transloco }}<p-sortIcon field="noti" />
                </div>
            </th>
            <th style="padding-top: 8px !important; padding-bottom: 8px !important;">
                <p-columnFilter style="width: 100%" type="text" [showMenu]="false" field="addressFull"
                    matchMode="contains">
                    <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                        <sh-search id="bookmark-menu-search-address" no-border [attr.label]="'bookmarks.sites.filter.address' | transloco" condensed [(ngModel)]="searchTermAddress"
                            (ngModelChange)="filter($event)"></sh-search>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th style="padding-top: 8px !important; padding-bottom: 8px !important;" alignFrozen="right" pFrozenColumn>
            </th>
        </tr>

    </ng-template>

    <!-- Rows -->
    <ng-template pTemplate="body" let-row let-expanded="expanded">
        <tr *ngIf="row.location_name ? true : false">
            <td pFrozenColumn style="z-index: 1;">
                <sh-button id="bookmark-menu-button-49" (click)="changeSite(row)" [label]="row.location_name" color="secondary"
                    size="auto"></sh-button>
            </td>
            <td>
                <div style="display: flex; align-items: center;">
                    <div style="height: 14px; width: 18px; min-width: 18px; margin-right: 4px; cursor: help; display: inline-block; position: relative; z-index: 0;"
                        [class]="'fi fis fi-'+row?.country?.toLowerCase() "></div>
                    <span>{{row?.country}}</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.time_windows?.[selectedRange+'']?.maintenance" type='warning' size="medium" show-label="true"
                        [label]="row.system_health.time_windows[selectedRange+''].maintenance+''"></sh-badge>
                    <span *ngIf="!row.system_health?.time_windows?.[selectedRange+'']?.maintenance">-</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.time_windows?.[selectedRange+'']?.autochecks" type='warning' size="medium" show-label="true"
                        [label]="row.system_health.time_windows[selectedRange+''].autochecks+''"></sh-badge>
                    <span *ngIf="!row.system_health?.time_windows?.[selectedRange+'']?.autochecks">-</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.time_windows?.[selectedRange+'']?.error_events" type='warning' size="medium" show-label="true"
                        style="background-color: var(--success-icon-color) !important"
                        [label]="row.system_health.time_windows[selectedRange+''].error_events+''"></sh-badge>
                    <span *ngIf="!row.system_health?.time_windows?.[selectedRange+'']?.error_events">-</span>
                </div>
            </td>
            <td *ngIf="showMachineDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true" *ngIf="row.system_health?.time_windows?.[selectedRange+'']?.qc" type='warning' size="medium" show-label="true"
                        style="background-color: var(--success-icon-color) !important"
                        [label]="row.system_health.time_windows[selectedRange+''].qc+''"></sh-badge>
                    <span *ngIf="!row.system_health?.time_windows?.[selectedRange+'']?.qc">-</span>
                </div>
            </td>
            <td *ngIf="showServiceDataColumns">
                <div style="display: flex; justify-content: flex-end; align-items: center;">
                    <sh-badge id="bookmark-menu-badge-true"
                        *ngIf="row.service_history?.time_windows?.[selectedRange+'']?.notifications_open && !row.totally_down_count"
                        type='warning' size="medium" show-label="true"
                        [label]="row.service_history.time_windows[selectedRange+''].notifications_open+''"></sh-badge>
                    <sh-badge id="bookmark-menu-badge-true"
                        *ngIf="row.service_history?.time_windows?.[selectedRange+'']?.notifications_open && row.totally_down_count"
                        type='error' size="medium" show-label="true"
                        [label]="row.service_history.time_windows[selectedRange+''].notifications_open+''"></sh-badge>
                    <span *ngIf="!row.service_history?.time_windows?.[selectedRange+'']?.notifications_open">-</span>
                </div>
            </td>
            <td>
                {{row?.addressFull}}
            </td>
            <td pFrozenColumn alignFrozen="right">
                <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                    <sh-icon id="bookmark-menu-icon-open-link" button icon="open-link" size="s" (click)="changeSite(row)"></sh-icon>
                    <sh-icon id="bookmark-menu-icon-cancel" button icon="cancel" size="s" (click)="deleteBookmarkSite($event, row)"></sh-icon>
                </div>

            </td>

        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="siteTableColspan">
                <div *ngIf="!isError"
                    style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                    <span>{{ 'bookmarks.sites.empty' | transloco }}</span>
                </div>
                <div *ngIf="isError"
                    style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                    <sh-icon id="bookmark-menu-icon-error" icon="error" size="s"></sh-icon>
                    <span>{{ 'bookmarks.error.pullingData' | transloco }}</span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="paginatorleft">
        <div style="width: 160px;"></div>
    </ng-template>

    <ng-template pTemplate="paginatorright">
        <div style="display: flex; align-items: center; gap: 8px;">
            <span>{{ 'bookmarks.pagination.rowsPerPage' | transloco }}</span>
            <sh-dropdown id="bookmark-menu-dropdown-59" no-border condensed style="max-width: 80px;">
                <sh-menu-item id="bookmark-menu-menu-item-5" (click)="tableSites.rows = 5; tableSites.first = 0" label="5" [active]="tableSites.rows === 5"></sh-menu-item>
                <sh-menu-item id="bookmark-menu-menu-item-10" (click)="tableSites.rows = 10; tableSites.first = 0" label="10"
                    [active]="tableSites.rows === 10"></sh-menu-item>
                <sh-menu-item id="bookmark-menu-menu-item-20" (click)="tableSites.rows = 20; tableSites.first = 0" label="20"
                    [active]="tableSites.rows === 20"></sh-menu-item>
                <sh-menu-item id="bookmark-menu-menu-item-50" (click)="tableSites.rows = 50; tableSites.first = 0" label="50"
                    [active]="tableSites.rows === 50"></sh-menu-item>
            </sh-dropdown>
        </div>
    </ng-template>

</p-table>